
<div class="w-fit fx-center">
  <div class="fx-row mr-1">
    <ion-icon
      id="click-trigger"
      class="s-4" 
      [name]="icon"
      (click)="popover.present()">
    </ion-icon>
  </div>
  <div class="my-auto d-inline-block">
    <ng-content></ng-content>
  </div>
</div>
<ion-popover #popover>
  <ng-template>
    <ion-toolbar>
      <ion-item lines="none">
        <div class="mx-auto h6 text-accent text-uppercase">
          {{ title }}
        </div>
      </ion-item>
      <ion-buttons slot="end">
        <ion-button (click)="popover.dismiss()">
          <ion-icon
            class="text-grey-400"
            slot="icon-only"
            name="close-outline">
          </ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-content>
      <div class="mx-5 my-2 h-auto">
        <span class="text-400 text-grey-400">{{ text }}</span>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>
